import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Divider, Tabs, Tab, TabPanel } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject, TokenData } from '../App';
import InputColumn from '../components/InputColumn'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link } from "react-router-dom"
import DefaultSite from '../components/DefaultSite';
import RowAddPage from '../components/RowAddPage';
import RowEditPage from '../components/RowEditPage';
import AutocompleteText from '../components/AutocompleteText';
import AddIcon from '@mui/icons-material/Add';
import InputRow from "../components/InputRow";
import { OrdersDataGrid, productCellRenderer, formatId } from "./Orders";

const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

export default function OrdersFiles(props) {
    const [tabValue, setTabValue] = useState(0);
    const userPermissions = (React.useContext(TokenData)).permissions;
    function TabPanel(props) {
        return props.index == props.value && <Grid xs item >
            {props.children}
        </Grid>;
    }

    return <React.Fragment>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} >
            <Tabs value={tabValue} onChange={(e, value) => setTabValue(value)} centered variant="fullWidth">
                <Tab label="Czekające na zatwierdzenie" xs />
                {userPermissions.admin && <Tab label="Wymagajace administratora" xs />}
            </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0}>
            <OrdersDataGrid
                style={{ marginTop: "10px", height: "80vh" }}
                filterData={{
                    field: "products.status",
                    operator: "equals",
                    value: [-1, 0],
                }
                }
            />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
            <OrdersDataGrid
                style={{ marginTop: "10px", height: "80vh" }}
                filterData={{
                    field: "products.status",
                    operator: "equals",
                    value: 2,
                }}
            />
        </TabPanel>
    </React.Fragment>
}